// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"c38e685a","57":"08caa70e","244":"d5f3eef6","566":"eba0323f","654":"d72ea079","689":"e4816b72","760":"f9d4bef2","797":"fa5c0670","883":"5b83dffc","904":"7c83002e"}[chunkId] + ".chunk.js";
};